export function parseActivityDateTime(date, time) {
  if (!date) return null;
  const safeTime = time && /^\d{2}:\d{2}$/.test(time) ? time : '00:00';
  const parsed = new Date(`${date}T${safeTime}:00`);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function getActivitySchedule(activity) {
  const start = parseActivityDateTime(activity.date, activity.startTime || '00:00');
  const end = parseActivityDateTime(activity.date, activity.endTime || '23:59');
  return { start, end };
}

export function enrichActivity(activity, now = new Date()) {
  if (activity.status === 'cancelled') {
    return {
      ...activity,
      effectiveStatus: 'cancelled',
      progress: 0,
      isLocked: true,
      canUploadPhotos: false,
    };
  }

  const { start, end } = getActivitySchedule(activity);

  if (!start || !end) {
    return {
      ...activity,
      effectiveStatus: activity.status || 'not-started',
      progress: 0,
      isLocked: false,
      canUploadPhotos: false,
    };
  }



  if (now < start) {
    return {
      ...activity,
      effectiveStatus: 'not-started',
      progress: 0,
      isLocked: false,
      canUploadPhotos: false,
    };
  }

  if (now >= start && now <= end) {
    const total = end.getTime() - start.getTime();
    const elapsed = now.getTime() - start.getTime();
    const progress = total > 0 ? Math.min(100, Math.round((elapsed / total) * 100)) : 0;

    return {
      ...activity,
      effectiveStatus: 'in-progress',
      progress,
      isLocked: false,
      canUploadPhotos: false,
    };
  }

  const canUploadPhotos = true;

  return {
    ...activity,
    effectiveStatus: 'completed',
    progress: 100,
    isLocked: true,
    canUploadPhotos,
  };
}

export function enrichActivities(activities, now = new Date()) {
  return activities.map((activity) => enrichActivity(activity, now));
}

export function formatActivityTimeRange(activity) {
  const { start, end } = getActivitySchedule(activity);
  if (!start || !end) {
    return activity.date
      ? new Date(activity.date).toLocaleDateString('en-IN', {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
        })
      : 'N/A';
  }

  const dateLabel = start.toLocaleDateString('en-IN', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
  const startLabel = start.toLocaleTimeString('en-IN', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
  const endLabel = end.toLocaleTimeString('en-IN', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });

  return `${dateLabel} • ${startLabel} – ${endLabel}`;
}

export function getActivitySortTime(activity) {
  const { start } = getActivitySchedule(activity);
  if (start) return start.getTime();
  return activity.date ? new Date(activity.date).getTime() : 0;
}
